export const subjectValidationError = (title: string, description: string) => {
    if (!title.trim()) return 'Enter a subject name.';
    if (!description.trim()) return 'Enter a description.';
    return null;
};
